import React, { useState, Component, useMemo, useEffect } from "react";
import { Switch } from "@mui/material";
import DataTable from "../../_Components/DataTable";
import ApiPromoCode from "../../../../core/api/api.promoCode";
import _ from "lodash";
import SwalMessage from "../../_Components/SwalMessage";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

function DataGridPromoCode({
  data,
  setShowModalPromoCode,
  setShowModalQrPromoCode,
  setSelectedPromoCodeId,
  setSelectedQrCode,
}) {
  const handleChangeIsDefault = (name) => (event) => {
    callApiService(name, 1);
  };
  async function callApiService(item, flag) {
    const response = await ApiPromoCode.removePromoCodeUser({
      id: item,
    });
    if (response.succeeded == true)
      document.getElementById("submitButton").click();

    SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  }
  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "شماره",
      minWidth: 50,
    },
    {
      accessor: "code",
      Header: "کد تخفیف",
      minWidth: "100px",
    },
    {
      accessor: "promoCodeUser[0].userPhoneNumber",
      Header: "شمراه همراه گردشگر",
      minWidth: "100px",
    },
    {
      accessor: "expireDate",
      Header: "تاریخ انقضا",
      minWidth: "100px",
      Cell: ({ row }) => <>{row.original.expireDate}</>,
    },
    {
      accessor: "promoCategoryS",
      Header: "نام گروه تخفیف",
      minWidth: "100px",
    },
    {
      Header: "وضعیت کد تخفیف",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Switch
            checked={
              row.original.promoCodeUser[0]?.isDeleted == true ? false : true
            }
            //checked={state.checkedA}
            value="row.original.promoCodeUser[0]?.isDeleted"
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
            onChange={handleChangeIsDefault(row.original.promoCodeUser[0]?.id)}
          />
        </div>
      ),
    },
    {
      Header: "عملیات",
      accessor: "",
      minWidth: 150,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Button
            title="ویرایش"
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            onClick={() => {
              setSelectedPromoCodeId(row.original.id);
              setShowModalPromoCode(true);
            }}
          >
            <i className="far fa-edit text-small"></i>
          </Button>
          <Link
            title="چاپ"
            to={`/printPromoCode/${row.original.id}`}
            className="btn btn-light-info btn-sm mr-2 btn-icon"
          >
            <i className="fas fa-print text-small"></i>
          </Link>
     
          <Button
            title="اطلاعات کد تخفیف"
            className="btn btn-light-success btn-sm mr-2 btn-icon"
            onClick={() => {
              setSelectedQrCode(row.original.code);
              setShowModalQrPromoCode(true);
            }}
          >
            <i className="fa fa-qrcode text-small "></i>
          </Button>
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGridPromoCode;
